export default __webpack_public_path__ + "static/media/MINUSMA_force_commander_visits_northern mali.248f817f.jpg";